// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicy_container__KUa7b","layout":"privacyPolicy_layout__EmZRc","back_btn":"privacyPolicy_back_btn__Q+hCD"};